export const BUSINESS_NAME_MAX = 80

/** Returns an error message, or null when the name is acceptable. */
export function validateBusinessName(raw: string): string | null {
  const name = raw.trim()
  if (name.length === 0) return 'Enter a business name.'
  if (name.length > BUSINESS_NAME_MAX) {
    return `Keep the name to ${BUSINESS_NAME_MAX} characters or fewer.`
  }
  return null
}

/**
 * Reduces whatever a person pastes to a bare host: lowercase, no scheme,
 * no leading `www.`, no path, query, fragment or trailing slash.
 */
export function normaliseDomain(raw: string): string {
  let d = raw.trim().toLowerCase()
  d = d.replace(/^https?:\/\//, '')
  d = d.split(/[/?#]/)[0] ?? ''
  d = d.replace(/^www\./, '')
  return d.trim()
}

/** A usable domain has a dot, no spaces, and no dot at either end. */
export function isValidDomain(domain: string): boolean {
  return (
    domain.includes('.') && !/\s/.test(domain) && !domain.startsWith('.') && !domain.endsWith('.')
  )
}
